import { DriverFilters } from "./../model/driver";
import {
  Http,
  Response,
  Headers,
  Request,
  RequestOptions,
} from "@angular/http";
import { throwError as observableThrowError, Observable } from "rxjs";
import { AuthHeaderService } from "../views/authheader.service";
import { environment } from "../../environments/environment";
import { Injectable } from "@angular/core";
import { map, catchError } from "rxjs/operators";
import { ReceiptPaymentForm } from "../model/receptPayment";
import { VendorReceiptPaymentForm } from "../model/vendorReceiptPayment";

@Injectable({
  providedIn: 'root'
})
export class ReceiptPaymentService {
  paymentReceiptUrl: string;
  settlearUrl:string
  constructor(private http: Http, private _headerService: AuthHeaderService) {
    this.paymentReceiptUrl = environment.paymentReceiptUrl;
    this.settlearUrl=environment.settlear
  }

  SendForm(pageFilters: any) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    // console.log(JSON.stringify(options));
    return this.http.post(this.paymentReceiptUrl, pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  SettleArForm(pageFilters: any) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    // console.log(JSON.stringify(options));
    return this.http.post(this.settlearUrl, pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getCustomerReceipt(invoiceType?) {
    let url = this.paymentReceiptUrl;
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    if(invoiceType){
      url = this.paymentReceiptUrl + '?invoiceType=' + invoiceType;
    }
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  SendFormVendor(pageFilters: VendorReceiptPaymentForm) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    // console.log(JSON.stringify(options));
    return this.http.post(this.paymentReceiptUrl + '/vendorPayment', pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }


}

